import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AuthService } from '@bya/auth/services/authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public auth: AuthService) { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      
      if(this.auth.isAuthenticated() == "true"){
        request = request.clone({
          setHeaders: {
            Authorization: this.auth.authorizationHeaderValue
          }
        });
      }
        
      return next.handle(request);
  }
}
